import { Location } from '@angular/common';
import { Component, Input } from '@angular/core';
@Component({
  imports: [],
  selector: 'sl-ui-kit-back-button',
  templateUrl: './back-button.component.html',
  styleUrls: ['./back-button.component.css']
})
export class BackButtonComponent {
  @Input()
  id: string;
  constructor(private _location: Location) {}
}
